jQuery(document).ready(function(){
  if(jQuery('.node-27').length > 0) {
    jQuery('.sous-menu-nav a[href*="#"]').on('click', function() {
      const $clickedLink = jQuery(this);
      const href = $clickedLink.attr('href');
      if (href && href.includes('#') && !href.startsWith('#')) {
        const $offCanvas = jQuery('.block-elton-extra-off-canvas-block-content');
        if ($offCanvas.length > 0) {
          $offCanvas.find('.part-droite button').trigger('click');
        }
      }
    });
  }
});
